// removed by extract-text-webpack-plugin
module.exports = {"tooltipContainer":"vaCBe","tooltipTrigger":"_2njeI"};